import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Divider, Grid, Paper, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
class JumlahUrlIklanMobile extends Component {
    state = { } 

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Jumlah URL Iklan"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}>
                        <Autocomplete
                            id="free-solo-2-demo"
                            // disableClearable
                            freeSolo 
                            options={this.props.cityList.map((option) => {
                                // console.log("LABEL : ", option);
                                return String(option);
                            })}
                            onChange={(event, newValue) => {
                                // console.log("NEWVALUE : ", event);
                                this.props.handleCityOnChange(newValue);
                                }} 
                            value={this.props.selectedCity}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Pilih Kota"
                                margin="0"
                                variant="outlined"
                                InputProps={{ ...params.InputProps, type: 'search' }}
                            />
                            )}
                            size='small'
                        />
                    </Filter>
                    {
                    this.props.contactLeadsDisplay.map((lead, index) => {
                        return (
                            <Box elevation={2} sx={{mb: "10px", padding: "10px"}} key={`itemleads-${index}`}>
                                <Grid container spacing={1}>
                                    <Grid item xs={10}>
                                        <Typography component="span">{lead.source_url}</Typography>
                                    </Grid>
                                    <Grid item xs={2} textAlign={"right"} sx={{pr: "5px"}}>
                                        {lead.count_url}
                                    </Grid>
                                </Grid>
                                <Divider />
                            </Box>
                        );
                    })
                }
                </Box>
            </Box>
        );
    }
}
 
export default JumlahUrlIklanMobile;